import React from 'react'
import Head, { PageHead } from '@fs/zion-head'

type AuthoritiesAppPageHeadProps = Readonly<{
  title: string
  description: string
  canonicalUrl: string
}>

export default function AuthoritiesAppPageHead({
  title,
  description,
  canonicalUrl,
}: AuthoritiesAppPageHeadProps): JSX.Element {
  return (
    <>
      <PageHead includeHreflang title={title} description={description} url={canonicalUrl} />
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
    </>
  )
}
